module.exports = __webpack_public_path__ + "img/new-logo.654a8ccf.png";